$(document).ready(function(){
  // $('html,body').animate({ scrollTop: 0 }, '1');
  var windowHeight = $(window).height();
  var titleHeight = $('.title').height();
  var windowWidth = $(window).width();
  var titleWidth = $('.title').width();
  var titlePosX = $('.title').offset().left;
  var titlePosY = $('.title').offset().top;
  $('.title').css('transform','translate('+(((windowWidth-titleWidth)/2-titlePosX))+'px,'+(((windowHeight-titleHeight)/2-titlePosY))+'px)');
  $('.title').addClass('active');
  setTimeout(function(){
    $('.title').css('transition','600ms');
    $('.title').addClass('active2');
    $('.overlay_white').fadeOut(1000);
  },1600);
  setTimeout(function(){
    $('.title').css('z-index','3');
  },2200);
});



$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });

  $('.sp_menu_btn').click(function(){
    $('header').toggleClass('open');
    $('body').toggleClass('open');
    $('.header_menu_wrapper a').click(function(){
      $('header').removeClass('open');
      $('body').removeClass('open');
    });
  });

  $('.header_switcher').click(function(){
    var fcs = $(this).data('s');
    var season = fcs.slice(2);
    $('.fcs_wrapper').attr('class', 'wrapper fcs_wrapper fcs' + fcs);
    $('.fcs_wrapper').attr('data-season',season);
    if (season=='win') {
      fall_win();
    }else if (season=='spr') {
      fall_spr();
    }
  });
  $('.season_switch ul li').click(function(){
    var fcs = $(this).data('s');
    var season = fcs.slice(2);
    $('.fcs_wrapper').attr('class', 'wrapper fcs_wrapper fcs' + fcs);
    $('.fcs_wrapper').attr('data-season',season);
    if (season=='win') {
      fall_win();
    }else if (season=='spr') {
      fall_spr();
    }
  });


$(window).on('load',function(){
  fall_spr();
});
$(window).on('resize',function(){
  var season = $('.fcs_wrapper').data('season');
  if (season=='win') {
    fall_win();
  }else if (season=='spr') {
    fall_spr();
  }
});

});


function fall_win() {
    if ($('.sp_only').css('display')=='none') {
    $(".content_right").snowfall('clear');
    $(".content_right").snowfall(
        {
            // 雪の量 (数値)
            flakeCount : 40,
            // 色 (RGB)
            // flakeColor : "",
            // z-indexの値
            flakeIndex : "1",
            // 最小サイズ （数値）
            minSize : 8,
            // 最大サイズ（数値）
            maxSize : 80,
            // 最低速度（数値）
            minSpeed : 1,
            // 最高速度（数値）
            maxSpeed : 3,
            // 雪の形を丸にする（boolean）
            round : true,
            // 影をつける（boolean）
            shadow : false,
            // 要素に積もらせる場合
            image : "https://cdn.shopify.com/s/files/1/0715/8959/3387/files/fcs24win_0-snow1.png"
            // オリジナル画像を使用する場合
            // image : "画像へのパス"
        }
      );
    }else{
    $(".content_bottom_container").snowfall('clear');
    $(".content_bottom_container").snowfall(
        {
            // 雪の量 (数値)
            flakeCount : 12,
            // 色 (RGB)
            // flakeColor : "",
            // z-indexの値
            flakeIndex : "1",
            // 最小サイズ （数値）
            minSize : 3,
            // 最大サイズ（数値）
            maxSize : 30,
            // 最低速度（数値）
            minSpeed : 1,
            // 最高速度（数値）
            maxSpeed : 3,
            // 雪の形を丸にする（boolean）
            round : true,
            // 影をつける（boolean）
            shadow : false,
            // 要素に積もらせる場合
            image : "https://cdn.shopify.com/s/files/1/0715/8959/3387/files/fcs24win_0-snow1.png"
            // オリジナル画像を使用する場合
            // image : "画像へのパス"
        }
      );
    }
}

function fall_spr() {
    if ($('.sp_only').css('display')=='none') {
    $(".content_right").snowfall('clear');
    $(".content_right").snowfall(
        {
            // 雪の量 (数値)
            flakeCount : 40,
            // 色 (RGB)
            // flakeColor : "",
            // z-indexの値
            flakeIndex : "1",
            // 最小サイズ （数値）
            minSize : 8,
            // 最大サイズ（数値）
            maxSize : 80,
            // 最低速度（数値）
            minSpeed : 1,
            // 最高速度（数値）
            maxSpeed : 3,
            // 雪の形を丸にする（boolean）
            round : true,
            // 影をつける（boolean）
            shadow : false,
            // 要素に積もらせる場合
            image : "https://cdn.shopify.com/s/files/1/0715/8959/3387/files/fcs25spr_0-sakura1.png?v=1736237974"
            // オリジナル画像を使用する場合
            // image : "画像へのパス"
        }
      );
    }else{
    $(".content_bottom_container").snowfall('clear');
    $(".content_bottom_container").snowfall(
        {
            // 雪の量 (数値)
            flakeCount : 12,
            // 色 (RGB)
            // flakeColor : "",
            // z-indexの値
            flakeIndex : "1",
            // 最小サイズ （数値）
            minSize : 3,
            // 最大サイズ（数値）
            maxSize : 30,
            // 最低速度（数値）
            minSpeed : 1,
            // 最高速度（数値）
            maxSpeed : 3,
            // 雪の形を丸にする（boolean）
            round : true,
            // 影をつける（boolean）
            shadow : false,
            // 要素に積もらせる場合
            image : "https://cdn.shopify.com/s/files/1/0715/8959/3387/files/fcs25spr_0-sakura1.png?v=1736237974"
            // オリジナル画像を使用する場合
            // image : "画像へのパス"
        }
      );
    }
}
